import MainContainer from "../../layout/MainContainer";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import React, { useState } from "react";
import {
    Autocomplete,
    Button,
    Checkbox,
    FormControlLabel,
    FormGroup,
    IconButton,
    MenuItem,
    Select,
    SelectChangeEvent,
    TextField,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import IosSwitchMain from "../../components/iosSwitchMain";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import EditText from "../../components/editText";

function AddUserBooking() {
    const navigate = useNavigate();
    const goBack = () => navigate(-1);

    const [isPartnerIncluded, setIsPartnerIncluded] = useState(false);
    const [isGuestIncluded, setIsGuestIncluded] = useState(false);

    const [value, setValue] = useState({
        type: "0",
        partnerType: "0",
        guestType: "0",
    });
    const [legal3, setLegal3] = useState<string>("");

    const handleChange1 = (event: SelectChangeEvent) => {
        const { name, value } = event.target;
        setValue((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const offerOptions = [
        "admin@yopmail.com",
        "john@yopmail.com",
        "adam@yopmail.com",
    ];

    return (
        <MainContainer>
            <div className="main_title d_flex">
                <div className="left_s">
                    <h1 className="back_arrow">
                        <IconButton onClick={goBack}>
                            <ArrowBackIcon />
                        </IconButton>
                        Add User
                    </h1>
                </div>
            </div>

            <div className="cards add_user_link">
                <div className="gap_p">
                    {/* Category Dropdown */}
                    <div className="control_group w_33">
                        <Select
                            className="dropse"
                            displayEmpty
                            name="type"
                            value={value.type}
                            onChange={handleChange1}
                            fullWidth
                        >
                            <MenuItem value="0" disabled>
                                Select Category
                            </MenuItem>
                            <MenuItem value="Dining">Dining</MenuItem>
                            <MenuItem value="Event">Event</MenuItem>
                            <MenuItem value="Contact Dealer">Contact Dealer</MenuItem>
                        </Select>
                    </div>

                    {/* Dining Fields */}
                    {value.type === "Dining" && (
                        <>
                            <div className="control_group w_33">
                                <Autocomplete
                                    disablePortal
                                    options={offerOptions}
                                    renderInput={(params) => (
                                        <TextField {...params} placeholder="Email Address" hiddenLabel fullWidth />
                                    )}
                                />
                            </div>

                            <div className="control_group w_33">
                                <TextField placeholder="Name" variant="outlined" fullWidth hiddenLabel />
                            </div>

                            <div className="control_group w_33">
                                <TextField placeholder="Dietary Requirement" variant="outlined" fullWidth hiddenLabel />
                            </div>

                            <div className="control_group w_33">
                                <TextField placeholder="No. of Guests" variant="outlined" fullWidth hiddenLabel />
                            </div>

                            <div className="control_group w_33">
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        slots={{
                                            openPickerIcon: () => (
                                                <img src="/static/images/calendar_icon.svg" alt="icon" />
                                            ),
                                            textField: (params) => (
                                                <TextField {...params} fullWidth placeholder="Select Date" hiddenLabel />
                                            ),
                                        }}
                                        desktopModeMediaQuery="(min-width:0px)"
                                    />
                                </LocalizationProvider>
                            </div>

                            <div className="control_group w_33">
                                <TextField placeholder="Time" variant="outlined" fullWidth hiddenLabel />
                            </div>

                            <div className="control_group w_100 prfrnc">
                                <label>Seating preferences</label>
                                <FormGroup row>
                                    <FormControlLabel control={<Checkbox defaultChecked />} label="Indoor Seating" />
                                    <FormControlLabel control={<Checkbox />} label="Outdoor Seating" />
                                </FormGroup>
                            </div>

                            <div className="control_group w_100 prfrnc">
                                <label>Do you comply with cancellation policy?</label>
                                <FormGroup>
                                    <FormControlLabel control={<Checkbox defaultChecked />} label="Cancellation Policy" />
                                </FormGroup>
                            </div>
                        </>
                    )}

                    {/* Event Fields */}
                    {value.type === "Event" && (
                        <>
                            <div className="control_group w_33">
                                <Autocomplete
                                    disablePortal
                                    options={offerOptions}
                                    renderInput={(params) => (
                                        <TextField {...params} placeholder="Email Address" hiddenLabel fullWidth />
                                    )}
                                />
                            </div>

                            <div className="control_group w_33">
                                <TextField placeholder="Name" variant="outlined" fullWidth hiddenLabel />
                            </div>

                            <div className="control_group w_33">
                                <TextField placeholder="Dietary Requirement" variant="outlined" fullWidth hiddenLabel />
                            </div>

                            <div className="control_group cncl_plcy w_50">
                                <label>Include Partner</label>
                                <IosSwitchMain
                                    checked={isPartnerIncluded}
                                    onChange={(e) => setIsPartnerIncluded(e.target.checked)}
                                />
                            </div>

                            {/* Partner Fields */}
                            {isPartnerIncluded && (
                                <>
                                    <div className="gap_p">
                                        <div className="control_group w_33">
                                            <TextField placeholder="Email" variant="outlined" fullWidth hiddenLabel />
                                        </div>
                                        <div className="control_group w_33">
                                            <TextField placeholder="Name" variant="outlined" fullWidth hiddenLabel />
                                        </div>
                                        <div className="control_group w_33">
                                            <TextField placeholder="Dietary Requirement" variant="outlined" fullWidth hiddenLabel />
                                        </div>
                                        <div className="control_group w_33">
                                            <Select
                                                className="dropse"
                                                displayEmpty
                                                name="partnerType"
                                                value={value.partnerType}
                                                onChange={handleChange1}
                                                fullWidth
                                            >
                                                <MenuItem value="0" disabled>Select Payar</MenuItem>
                                                <MenuItem value="10">Samantha</MenuItem>
                                                <MenuItem value="20">John</MenuItem>
                                            </Select>
                                        </div>
                                        <div className="control_group w_33">
                                            <TextField
                                                placeholder="Any special request or occasion?"
                                                variant="outlined"
                                                fullWidth
                                                hiddenLabel
                                            />
                                        </div>
                                    </div>

                                    <div className="control_group cncl_plcy w_50">
                                        <label>Include Guest</label>
                                        <IosSwitchMain
                                            checked={isGuestIncluded}
                                            onChange={(e) => setIsGuestIncluded(e.target.checked)}
                                        />
                                    </div>
                                </>
                            )}

                            {/* Guest Fields */}
                            {isGuestIncluded && (
                                <div className="gap_p">
                                    <div className="control_group w_33">
                                        <TextField placeholder="Email" variant="outlined" fullWidth hiddenLabel />
                                    </div>
                                    <div className="control_group w_33">
                                        <TextField placeholder="Name" variant="outlined" fullWidth hiddenLabel />
                                    </div>
                                    <div className="control_group w_33">
                                        <TextField placeholder="Dietary Requirement" variant="outlined" fullWidth hiddenLabel />
                                    </div>
                                    <div className="control_group w_50">
                                        <Select
                                            className="dropse"
                                            displayEmpty
                                            name="guestType"
                                            value={value.guestType}
                                            onChange={handleChange1}
                                            fullWidth
                                        >
                                            <MenuItem value="0" disabled>Select Payar</MenuItem>
                                            <MenuItem value="10">Samantha</MenuItem>
                                            <MenuItem value="20">John</MenuItem>
                                            <MenuItem value="30">Guest</MenuItem>
                                        </Select>
                                    </div>
                                    <div
                                        className="control_group w_50"
                                        style={{ display: "flex", justifyContent: "flex-end" }}
                                    >
                                        <Button className="btn btn_primary">Add More Guest</Button>
                                    </div>
                                </div>
                            )}
                        </>
                    )}
                    {value.type === "Contact Dealer" && (
                        <><div className="control_group w_33">
                            <Autocomplete
                                disablePortal
                                options={offerOptions}
                                renderInput={(params) => (
                                    <TextField {...params} placeholder="Email Address" hiddenLabel fullWidth />
                                )} />
                        </div><div className="control_group w_33">
                                <TextField placeholder="Name" variant="outlined" fullWidth hiddenLabel />
                            </div><div className="control_group w_33">
                                <TextField placeholder="Dietary Requirement" variant="outlined" fullWidth hiddenLabel />
                            </div>
                            <div className="control_group w_33">
                                <TextField
                                    placeholder="Any special request or occasion?"
                                    variant="outlined"
                                    fullWidth
                                    hiddenLabel
                                />
                            </div>
                            <div className="control_group w_33">
                                <TextField placeholder="Payment For User(Amount)" variant="outlined" fullWidth hiddenLabel />
                            </div>
                            <div className="control_group w_50">
                                <EditText content={legal3} setContent={setLegal3} />
                            </div>
                        </>


                    )}
                    {/* Save Button */}
                    <div className="mt_30">
                        <Button className="btn btn_primary">Save</Button>
                    </div>
                </div>
            </div>
        </MainContainer>
    );
}

export default AddUserBooking;
